import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import ArtistCard from "./Artists/ArtistCard";
import { distributionUrl } from "../../../Config/url";
import { useAxiosConfigGlobal } from "../../../Config/axios";
import Skeleton from "react-loading-skeleton";

const Wrapper = styled.div`
  .box {
    border-radius: 12px;
    border: 1px solid #d1d5db;
    background: #ffffff;
    border-radius: 12px;
    position: relative;
  }
`;

const Artists = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const [artists, setArtists] = useState([]);
  const [genres, setGenres] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const axiosConfig = useAxiosConfigGlobal();
  useEffect(() => {
    document.title = "MMusic - Профайл - Гэрээт уран бүтээлч";
  }, []);
  useEffect(() => {
    axios
      .get(
        distributionUrl + `panel-api/oauth/artists?include[genres]=true `,
        axiosConfig
      )
      .then((res) => {
        setArtists(res.data.data);
        setLoaded(true);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
    axios
      .get(distributionUrl + "panel-api/oauth/genres", axiosConfig)
      .then((res) => {
        setGenres(res.data.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  }, []);
  const artistMap = artists.map((artist) => {
    const SGFirst = artist.secondary_genres
      .map((a) => {
        return a.name;
      })
      .join(", ");
    return (
      <ArtistCard
        oneRingRulesAll={oneRingRulesAll}
        isUserCanEdit={isUserCanEdit}
        key={artist.id}
        data={artist}
        genres={genres}
        SGFirst={SGFirst}
        setCKPopup={setCKPopup}
        setCKPopupType={setCKPopupType}
        setCKPopupMessage={setCKPopupMessage}
      />
    );
  });
  return (
    <Wrapper className="p-3 md:p-4">
      {loaded ? (
        <div className="flex flex-col gap-6">{artistMap}</div>
      ) : (
        <div className="flex flex-col gap-6">
          <div className="w-full h-full text-center opacity-50">
            <Skeleton count={1} width="100%" height="200px" />
          </div>
          <div className="w-full h-full text-center opacity-50">
            <Skeleton count={1} width="100%" height="200px" />
          </div>
          <div className="w-full h-full text-center opacity-50">
            <Skeleton count={1} width="100%" height="200px" />
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default Artists;
